import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import clockIcon from "../assets/clock.svg";
import callIcon from "../assets/call.svg";
import "../styles/navbar.css";

const ORDER_URL = "https://debrecenipizza.hu/";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [open]);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const close = () => setOpen(false);

  const menuItems = [
    { to: "/", label: "Főoldal", type: "route" },
    { to: "/etlap", label: "Étlap", type: "route" },
    { to: "/aktualis-akciok", label: "Aktuális akciók", type: "route" },
    { to: "/franchise", label: "Franchise", type: "route" },
    { href: ORDER_URL, label: "Online rendelés", type: "external" },
  ];

  return (
    <header className="ph-nav">
      <div className="ph-container">
        {/* Brand */}
        <Link to="/" className="ph-brand" aria-label="Pizza Home – Debrecen">
          <img
            src="/images/logo.webp"
            width="120"
            height="36"
            alt="Pizza Home Debrecen logó"
            className="ph-logo"
          />
        </Link>

        {/* Desktop */}
        <nav className="ph-desktop">
          <ul className="ph-menu">
            {menuItems.map((m) => (
              <li key={m.label}>
                {m.type === "route" ? (
                  <NavLink
                    to={m.to}
                    className={({ isActive }) =>
                      `ph-link${isActive ? " active" : ""}`
                    }
                  >
                    {m.label}
                  </NavLink>
                ) : (
                  <a className="ph-link" href={m.href} rel="noopener">
                    {m.label}
                  </a>
                )}
              </li>
            ))}
          </ul>

          <div className="ph-right">
            <div className="ph-info">
              <span
                className="ph-icon"
                aria-hidden="true"
                style={{ backgroundImage: `url(${clockIcon})` }}
              />
              <div className="ph-info-text">
                <span className="ph-info-top">Nyitvatartás</span>
                <span className="ph-info-bold">Hamarosan</span>
              </div>
            </div>

            <a href="#" className="ph-info ph-phone">
              <span
                className="ph-icon"
                aria-hidden="true"
                style={{ backgroundImage: `url(${callIcon})` }}
              />
              <span className="ph-info-bold">Hamarosan</span>
            </a>
          </div>
        </nav>

        {/* Burger (mobile) */}
        <button
          className={`ph-burger ${open ? "is-open" : ""}`}
          aria-label="Menü"
          aria-expanded={open}
          onClick={() => setOpen((s) => !s)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile overlay */}
      <div
        className={`ph-overlay ${open ? "show" : ""}`}
        role="dialog"
        aria-modal="true"
      >
        <div className="ph-overlay-panel">
          <ul className="ph-overlay-menu">
            {menuItems.map((m) => (
              <li key={m.label}>
                {m.type === "route" ? (
                  <NavLink
                    to={m.to}
                    className={({ isActive }) =>
                      `ph-link-mobile${isActive ? " active" : ""}`
                    }
                    onClick={close}
                  >
                    {m.label}
                  </NavLink>
                ) : (
                  <a
                    className="ph-link-mobile"
                    href={m.href}
                    rel="noopener"
                    onClick={close}
                  >
                    {m.label}
                  </a>
                )}
              </li>
            ))}
          </ul>

          <div className="ph-overlay-info">
            <div className="ph-info line">
              <span
                className="ph-icon"
                aria-hidden="true"
                style={{ backgroundImage: `url(${clockIcon})` }}
              />
              <div className="ph-info-text">
                <span className="ph-info-top">Nyitvatartás</span>
                <span className="ph-info-bold">Hamarosan</span>
              </div>
            </div>

            <a href="#" className="ph-info ph-phone line">
              <span
                className="ph-icon"
                aria-hidden="true"
                style={{ backgroundImage: `url(${callIcon})` }}
              />
              <span className="ph-info-bold">Hamarosan</span>
            </a>
          </div>
        </div>

        <button
          className="ph-overlay-backdrop"
          aria-label="Bezárás"
          onClick={close}
        />
      </div>
    </header>
  );
}
